import React from 'react';

const TraceOnBtn = (props) => (
    <div 
    	className={`trace-on-btn trace-btn ${props.selected && 'on'}`} 
    	onClick={props.onClick}
    ></div>
);

export default TraceOnBtn;


// WEBPACK FOOTER //
// ./src/components/sections/shared/TraceOnBtn.js